module.exports = __webpack_public_path__ + "static/media/greeting.7141b6e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/screens/registration/greeting.svg
// module id = 1047
// module chunks = 0